module.exports = __webpack_public_path__ + "img/sideHelp2.c7562442.svg";